/* =========================================================
   FITNES DREHI · SIDE CART
   Публично API (за landing страници, бутони и др.):
     SideCart.open() / SideCart.close()
     SideCart.add([{ id: variantId, quantity: 1 }])   -> Promise
     SideCart.refresh()                                -> Promise
     SideCart.state()  -> { count, eligible, tier, nextQty, nextPct, total }
   Събитие: document 'sidecart:updated' (detail = state)
   Обновяването е чрез Shopify Section Rendering API: HTML-ът идва от Liquid,
   затова цените, старите цени и отстъпките са винаги реалните.
   ========================================================= */
(function () {
  'use strict';
  var root = document.querySelector('[data-sc]');
  if (!root || window.SideCart) return;

  var SID = root.getAttribute('data-section-id');
  var BUBBLE = root.getAttribute('data-bubble-section') || '';
  var OPEN_ON_ADD = root.getAttribute('data-open-on-add') === 'true';
  var BASE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SECTIONS = [SID].concat(BUBBLE ? [BUBBLE] : []).join(',');
  var lastFocus = null;

  /* ---------- open / close ---------- */
  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    document.documentElement.classList.add('sc-lock');
    var dr = root.querySelector('.sc-dr');
    if (dr) dr.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('sidecart:open'));
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('sc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('sidecart:close'));
  }

  /* ---------- state ---------- */
  function state() {
    var el = root.querySelector('[data-sc-state]');
    try { return JSON.parse(el.textContent); } catch (e) { return { count: 0 }; }
  }
  function emit() {
    document.dispatchEvent(new CustomEvent('sidecart:updated', { detail: state() }));
  }

  /* ---------- section rendering ---------- */
  function apply(sections) {
    if (!sections) return;
    var html = sections[SID];
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-sc-inner]');
      var cur = root.querySelector('[data-sc-inner]');
      if (next && cur) {
        var body = cur.querySelector('.sc-body');
        var top = body ? body.scrollTop : 0;
        cur.parentNode.replaceChild(next, cur);
        var nb = next.querySelector('.sc-body');
        if (nb) nb.scrollTop = top;
      }
    }
    if (BUBBLE && sections[BUBBLE]) {
      var target = document.getElementById(BUBBLE);
      if (target) {
        var d2 = new DOMParser().parseFromString(sections[BUBBLE], 'text/html');
        var src = d2.getElementById('shopify-section-' + BUBBLE) || d2.body;
        target.innerHTML = src.innerHTML;
      }
    }
    tick();
    emit();
  }

  function busy(on) { root.classList.toggle('is-busy', !!on); }

  function request(url, body) {
    var isForm = body instanceof FormData;
    return fetch(BASE + url, {
      method: 'POST',
      headers: isForm ? { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
                      : { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: isForm ? body : JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw j;
        return j;
      });
    });
  }

  function add(items) {
    busy(true);
    return request('cart/add.js', { items: items, sections: SECTIONS, sections_url: location.pathname })
      .then(function (res) { apply(res.sections); if (OPEN_ON_ADD) open(); return res; })
      .catch(fail)
      .then(function (r) { busy(false); return r; });
  }

  function addForm(form, submitter) {
    var fd = new FormData(form);
    if (submitter && submitter.name) fd.append(submitter.name, submitter.value);
    fd.append('sections', SECTIONS);
    fd.append('sections_url', location.pathname);
    var btn = submitter || form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    busy(true);
    return request('cart/add.js', fd)
      .then(function (res) { apply(res.sections); if (OPEN_ON_ADD) open(); return res; })
      .catch(fail)
      .then(function (r) {
        busy(false);
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
        return r;
      });
  }

  function change(key, qty) {
    busy(true);
    return request('cart/change.js', { id: key, quantity: qty, sections: SECTIONS, sections_url: location.pathname })
      .then(function (res) { apply(res.sections); return res; })
      .catch(fail)
      .then(function (r) { busy(false); return r; });
  }

  function refresh() {
    return fetch(location.pathname + '?sections=' + encodeURIComponent(SECTIONS), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () {});
  }

  function fail(err) {
    toast((err && (err.description || err.message)) || root.getAttribute('data-t-error') || 'Error');
    return null;
  }

  /* ---------- clicks inside the cart ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!root.contains(t)) return;
    if (t.closest('[data-sc-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest('[data-sc-qty]');
    if (q) { e.preventDefault(); change(q.getAttribute('data-key'), +q.getAttribute('data-sc-qty')); return; }
    var x = t.closest('[data-sc-xs-add]');
    if (x) {
      e.preventDefault();
      var v = x.closest('.sc-x').querySelector('[data-sc-variant]');
      x.disabled = true;
      add([{ id: +v.value, quantity: 1 }]).then(function () { x.disabled = false; });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  /* ---------- open from anywhere: [data-sc-open] and the theme cart icon ---------- */
  var ICON = root.getAttribute('data-icon-selector');
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-sc-open]' + (ICON ? ', ' + ICON : ''));
    if (!el || root.contains(el)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  /* ---------- take over "Add to cart" forms site-wide ---------- */
  if (root.getAttribute('data-intercept-forms') === 'true') {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!(f instanceof HTMLFormElement)) return;
      if (!/\/cart\/add/.test(f.getAttribute('action') || '')) return;
      if (f.closest('[data-sc-skip]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addForm(f, e.submitter);
    }, true);
  }

  /* ---------- timers ---------- */
  function p2(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var now = Date.now();
    var els = root.querySelectorAll('[data-sc-timer]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = Date.parse(el.getAttribute('data-end'));
      if (isNaN(end)) continue;
      var d = Math.max(0, end - now);
      if (!d && el.getAttribute('data-hide-end') === 'true') { el.classList.add('is-ended'); continue; }
      var D = Math.floor(d / 864e5), H = Math.floor(d / 36e5) % 24, M = Math.floor(d / 6e4) % 60, S = Math.floor(d / 1e3) % 60;
      var t = el.querySelector('[data-sc-t]');
      if (t) t.textContent = (D ? D + (root.getAttribute('data-t-day') || 'd') + ' ' : '') + p2(H) + ':' + p2(M) + ':' + p2(S);
      var urgent = d > 0 && d < (+el.getAttribute('data-urgent') || 0) * 36e5;
      el.classList.toggle('is-urgent', urgent);
      var tx = el.querySelector('[data-sc-timer-text]');
      if (tx) {
        if (!tx._def) tx._def = tx.textContent;
        tx.textContent = urgent && el.getAttribute('data-urgent-text') ? el.getAttribute('data-urgent-text') : tx._def;
      }
    }
  }
  setInterval(tick, 1000);

  /* ---------- toast ---------- */
  var toastEl;
  function toast(m) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'sc-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = m;
    toastEl.classList.add('is-show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2800);
  }

  /* ---------- Theme Editor: секцията се пререндерира при всяка промяна ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-sc]');
    if (!r) return;
    root = r;
    tick();
    emit();
  });
  document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(root)) open(); });
  document.addEventListener('shopify:block:select', function (e) { if (root.contains(e.target)) open(); });

  /* Връщане назад (bfcache): количката може да е остаряла */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.SideCart = { open: open, close: close, add: add, refresh: refresh, state: state, toast: toast };
  tick();
  emit();
})();
